// extracted by mini-css-extract-plugin
export default {"wrapper":"LoaderContextProvider_wrapper__H1LRi"};